import React, { Component } from "react"
import { Card, CardBody, CardTitle, Badge, Button, Container, Row, Col, Alert } from "reactstrap"
import MetaTags from 'react-meta-tags';
import PropTypes from 'prop-types'
import { withTranslation } from "react-i18next"
import { connect } from "react-redux"
import { toast } from "react-toastify";
import { API_URL } from "helpers/app_url";
class UnsubscribePage extends Component {
  constructor(props) {
    super(props)
   this.state = {
      email: '',
      unsubscribed: false,
      validationErrors: []
    };
  }

  componentDidMount() {
    const params = new URLSearchParams(window.location.search);
    const email = params.get('emailAddress');
    if (email) {
      this.setState({ email });
    }
   
  }

handleUnsubscribe = async () => {
  const { email } = this.state;
  if (!email) return;
  try {
    const response = await fetch(
      `${API_URL}EmailUnsubscribeQueue/AddEmailUnsubscribeQueue?emailAddress=${encodeURIComponent(email)}`
    );
    const data = await response.json();
    if (data.success) {
      this.setState({ unsubscribed: true, validationErrors: [] });
    } else if (
      data.validationErrors &&
      data.validationErrors.includes("A Record with the same email and Category already exists.")
    ) {
      this.setState({ unsubscribed: true, validationErrors: [] });
    } else {
      this.setState({ validationErrors: data.validationErrors || [] });
      toast.dismiss();
      toast.warning('Some issue please try again');
    }
  } catch (error) {
    alert("An error occurred. Please try again.");
  }
};

  render() {
 
    return (
      <React.Fragment>
       
        <MetaTags>
          <title>Unsubscribe | Realty Space</title>
        </MetaTags>
       
     
            <div className="page-content">

              <Container fluid className="h-100">
               
                <Row className="h-100 justify-content-center align-items-center">
                
                <Col sm="4"></Col>
                <Col xl="3">
                     <Card className="newCard">
                        
                      <CardBody className="unsubscribeText">
                  {this.state.unsubscribed ? (
                    <h1>You have successfully been unsubscribed</h1>
                  ) : (
                    <>
                      <h1>Do you want to Unsubscribe?</h1>
                      <p>If you would like to unsubscribe from future emails sent from Rise Worldwide, Inc., please use the following options...</p>
                      {this.state.validationErrors.length > 0 && (
                        <Alert color="danger">
                          {this.state.validationErrors.map((err, idx) => (
                            <div key={idx}>{err}</div>
                          ))}
                        </Alert>
                      )}
                      <button className="btn btn-black" onClick={this.handleUnsubscribe}>Unsubscribe</button>
                    </>
                  )}
                </CardBody>
                    </Card>
                </Col>
                <Col xl="4"></Col>
                </Row>

              </Container>
            </div>
        
      </React.Fragment>
    )
  }
}
UnsubscribePage.propTypes = {

}

const mapStateToProps = ({ }) => (
  {

  })
const mapDispatchToProps = dispatch => ({
 
});

export default connect(mapStateToProps, mapDispatchToProps)(withTranslation()(UnsubscribePage));


